var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57653 1.70401C4.21002 0.568002 4.52651 0 5 0C5.47349 0 5.78998 0.568002 6.42347 1.70401L6.58746 1.99801C6.76746 2.32101 6.85746 2.48251 6.99745 2.58901C7.13745 2.69551 7.31245 2.73501 7.66244 2.81401L7.98043 2.88601C9.2104 3.16451 9.82489 3.30351 9.97138 3.77401C10.1174 4.24401 9.69839 4.73451 8.85991 5.71502L8.64291 5.96852C8.40492 6.24702 8.28542 6.38652 8.23192 6.55852C8.17842 6.73102 8.19642 6.91702 8.23242 7.28852L8.26542 7.62702C8.39192 8.93553 8.45542 9.58953 8.07243 9.88003C7.68944 10.171 7.11345 9.90553 5.96248 9.37553L5.66398 9.23853C5.33699 9.08753 5.1735 9.01253 5 9.01253C4.8265 9.01253 4.66301 9.08753 4.33602 9.23853L4.03802 9.37553C2.88655 9.90553 2.31056 10.1705 1.92807 9.88053C1.54458 9.58953 1.60808 8.93553 1.73458 7.62702L1.76758 7.28902C1.80358 6.91702 1.82157 6.73102 1.76758 6.55902C1.71458 6.38652 1.59508 6.24702 1.35709 5.96902L1.14009 5.71502C0.301611 4.73501 -0.11738 4.24451 0.0286168 3.77401C0.175113 3.30351 0.790099 3.16401 2.02007 2.88601L2.33806 2.81401C2.68755 2.73501 2.86205 2.69551 3.00255 2.58901C3.14254 2.48251 3.23254 2.32101 3.41254 1.99801L3.57653 1.70401Z",
    fill: "#FFD233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c66b438950f7fa4c126dbdb4cb2a8bf0.svg";
export { ForwardRef as ReactComponent };